import { render } from "./addElem.vue?vue&type=template&id=675c51a1"
import script from "./addElem.vue?vue&type=script&lang=js"
export * from "./addElem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__